import React, {Component} from 'react';
import PropTypes from 'prop-types';
const { URL } = window;
export default class TwitterIcon extends Component{
    constructor(props){
        super(props);
    }

    render(){
        const { title } = document;
        let docUrl = new URL(document.location);
        docUrl.searchParams.set("src","sttwit");
        let targetUrl = new URL("https://twitter.com/share");
        targetUrl.searchParams.set("url",docUrl.href);
        targetUrl.searchParams.set("text",title);
        
        const aProps = {
            href: targetUrl.href,
            target: "_blank",
            onClick: this.props.onClick
        }
        return(
            <div className="twitter-icon icon-container">
                <a {...aProps} >
                    <span className="icon-title">Twitter</span>
                    <svg width="14" height="11" viewBox="0 0 14 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g transform="translate(-155.000000, -965.000000)" fill="#2DA7DC">
                                <g transform="translate(115.000000, 954.000000)">
                                    <path d="M53.6129288,11.2025943 C53.0572764,11.5206456 52.4428424,11.7526488 51.7873723,11.8768195 C51.2649925,11.336568 50.5185772,11 49.6911986,11 C48.1052048,11 46.8197734,12.2427963 46.8197734,13.7764135 C46.8197734,13.9942569 46.8452824,14.2055649 46.8929731,14.4092484 C44.5062188,14.2937915 42.3889725,13.1882365 40.9726689,11.507575 C40.7253426,11.9182097 40.5833795,12.3952867 40.5833795,12.9039509 C40.5833795,13.8679077 41.1822863,14.7174968 41.9519924,15.2152688 C41.4817397,15.201109 40.7419789,15.0758491 40.7419789,14.8678087 L40.7419789,14.9026636 C40.7419789,16.2478463 41.6414482,17.3708288 42.9557158,17.6267947 C42.7139349,17.6899693 42.4155906,17.723735 42.1527371,17.723735 C41.9675196,17.723735 41.7656658,17.7063076 41.5893211,17.6736311 C41.9564287,18.7770076 43.0045156,19.5797604 44.2622198,19.6026339 C43.27846,20.346569 42.0351739,20.7909694 40.6876337,20.7909694 C40.4558346,20.7909694 40.2251446,20.7778988 40,20.7528468 C41.2721223,21.5403505 42.7804801,22 44.4019647,22 C49.6867623,22 52.5737146,17.7683929 52.5737146,14.0988217 C52.5737146,13.9790078 52.5726056,13.8581048 52.5670601,13.7393801 C53.1271489,13.3483513 53.615147,12.859293 54,12.301614 C53.4842747,12.522725 52.9308405,12.6719477 52.3496792,12.7383899 C52.9430405,12.3952867 53.397766,11.8517675 53.6129288,11.2025943"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                </a>
            </div>
        )
    }
    static get propTypes() {
        return {
            onClick: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            onClick: () => {}
        }
    }
}
